export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_q04_a.efb8072a.png";